var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"privacy-text"},[_vm._v(" "+_vm._s(_vm.$t('privacyText'))+" "),_c('span',{staticClass:"view-privacy-policy",on:{"click":_vm.viewPrivacyPolicy}},[_vm._v(" "+_vm._s(_vm.$t('global.viewPrivacyPolicy'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }